import { Typography, Box, Button } from '@mui/material';
import { useAppDispatch, useAppSelector } from '../utils/hooks';
import { incrementStep } from '../store/reducers/stepper.reducers';
import { formatNumber } from 'src/utils/numberFormater';

interface Props {
  totalAmount: number;
  disable: boolean;
  hide: boolean;
  text: string;
}
export default function TotalAmount({
  totalAmount,
  disable,
  text,
  hide,
}: Props) {
  const dispatch = useAppDispatch();
  const { isColorBlindMode } = useAppSelector((state) => state.config);
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'flex-end',
        alignItems: 'flex-end',
        flexDirection: 'column',
        marginY: '20px',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          flexDirection: 'column',
        }}
      >
        <Typography variant="h5">{text}:</Typography>
        <Typography variant="h5">
          {formatNumber(totalAmount)}{' '}
          {isColorBlindMode ? 'EUR einmal in jedem Monat' : 'EUR / Monat'}
        </Typography>
        <Button
          variant="contained"
          size="large"
          disabled={disable || totalAmount <= 0.005}
          sx={[
            hide ? { display: 'none', width: '250px' } : { width: '250px' },
            {
              whiteSpace: 'nowrap',
            },
            isColorBlindMode && {
              backgroundColor: 'accessibility.button.main',
              color: 'accessibility.button.contrastText',
              textDecoration: 'underline',
              textUnderlineOffset: '2.5px',
              border: (theme) =>
                `1px solid ${theme.palette.accessibility?.button?.border}`,
              '&:hover': {
                backgroundColor: '#222',
                color: 'accessibility.button.contrastText',
                textDecoration: 'underline',
              },
            },
          ]}
          onClick={() => {
            dispatch(incrementStep());
          }}
        >
          Beantragung Starten
        </Button>
      </Box>
    </Box>
  );
}
